import {inject, injectable} from 'inversify';

import type {CromModel} from '../domain/Crom/Crom.model';

import {logger} from '../../../../utils/logger';
import {FetchCromByIdQuery} from '../ports/fetchCromById/FetchCromById.query';

@injectable()
export class FetchCromByIdUseCase {
  constructor(
    @inject(FetchCromByIdQuery)
    private readonly fetchByIdPort: FetchCromByIdQuery,
  ) {}

  execute(cromId: string): Promise<CromModel> {
    try {
      return this.fetchByIdPort.fetchById(cromId);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}
